import { PASTEL } from "@/lib/pastel";

export const PHASES = [
  { id: "intake", name: "Intake", stages: [1, 2, 3, 4], pastel: PASTEL.yellow },
  { id: "clinical", name: "Clinical & MD", stages: [5, 6, 7, 8, 9], pastel: PASTEL.green },
  { id: "authorization", name: "Authorization", stages: [10, 11, 12, 13], pastel: PASTEL.blue },
  { id: "start", name: "Start of Care", stages: [14, 15, 16], pastel: PASTEL.violet },
];

export const RECRUITING_PHASES = [
  { id: "applicants", name: "Applicants", stages: [101, 102], pastel: PASTEL.yellow },
  { id: "interviewing", name: "Interviewing", stages: [103, 104], pastel: PASTEL.green },
  { id: "vetting", name: "Vetting & Offer", stages: [105, 106], pastel: PASTEL.blue },
  { id: "onboarding", name: "Onboarding", stages: [107, 108, 109], pastel: PASTEL.violet },
];

export const getPhases = (workspace) => (workspace === "recruiting" ? RECRUITING_PHASES : PHASES);

export const phaseForStage = (stage) => [...PHASES, ...RECRUITING_PHASES].find((p) => p.stages.includes(stage));
